// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1848":"773124b54765aa8d","2682":"99de285906e324f5","6714":"f66d4429738d4ece"}[chunkId] + ".css";
};